import type { Dispatch, SetStateAction } from 'react';

export const revealHiddenSection = (
  el: HTMLElement,
  setHiddenSections: Dispatch<SetStateAction<number[]>>,
) => {
  const hiddenWidget = el.closest('.widgetHidden');
  if (hiddenWidget) {
    const sectionClass = [...hiddenWidget.classList].find((className) =>
      className.startsWith('widget-section'),
    );
    if (sectionClass) {
      const sectionId = sectionClass.replace('widget-section-', '');
      setHiddenSections((prev) =>
        prev.filter((id) => id !== parseInt(sectionId, 10)),
      );
    }
  }
};

export const revealHiddenTarget =
  (setHiddenSections: Dispatch<SetStateAction<number[]>>) =>
  (target: string | HTMLElement) => {
    const icon: HTMLElement | null =
      typeof target === 'string' ? document.querySelector(target) : target;
    if (icon && !icon?.offsetParent) {
      revealHiddenSection(icon as HTMLElement, setHiddenSections);
    }
  };

export const getInternalLinkHandler =
  (
    setHiddenSections: Dispatch<SetStateAction<number[]>>,
    highlightClass = 'widget-highlight',
  ) =>
  (el: HTMLElement) => {
    revealHiddenSection(el, setHiddenSections);
    const widget = el.firstElementChild;
    if (!widget) return;
    widget.scrollIntoView({ behavior: 'smooth' });
    widget.classList.add(highlightClass);
    setTimeout(() => {
      widget.classList.remove(highlightClass);
    }, 2500);
  };

export const getWidgetId = (id: string | number) => `widget-${id}`;

export const hideWidget = (
  id: number | string,
  widgetRef?: HTMLElement | null,
) => {
  const widgetId = getWidgetId(id);
  let widget = widgetRef;
  if (!widget) {
    widget = document.getElementById(widgetId);
  }
  if (widget) {
    widget.id = widget.id.replace(widgetId, '');
    widget.style.display = 'none';
  }
  return widget;
};

export const showWidget = (
  id: number | string,
  widgetRef: HTMLElement | null,
) => {
  if (!widgetRef) return;

  const widgetId = getWidgetId(id);
  if (widgetId !== widgetRef.id) {
    widgetRef.id = widgetId;
  }
  if (widgetRef.style.display === 'none') {
    widgetRef.style.display = 'initial';
  }
};
